import {RouterModule, Routes} from '@angular/router';

const APP_ROUTES: Routes = [
  { path: '**', redirectTo: '/module/home' }
];

export const routing = RouterModule.forRoot(APP_ROUTES);
